module.exports = crypto;


//////////////////
// WEBPACK FOOTER
// external "crypto"
// module id = 8
// module chunks = 0